angular.module('aq.filters.formatters')
.filter('zeroToNull', function() {
    return function(input) {
        if (input === 0) return null;
        return input;
    }
});